import {
  addSubCategoryMutation,
  deleteSubCategoryMutation,
  updateSubCategoryStatusMutation,
} from '../../../lib/graphql';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';

// Category Studio: inline subcategory management from the category tree.
// Unlike the standalone actions, these never navigate away and just return { status }
// so the tree can refetch in place.

export const saveSubCategoryInline = (id, name, categoryId, status) => {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation: addSubCategoryMutation,
        variables: { id: id || undefined, name, categoryId: Number(categoryId), status: status || 'active' },
      });
      if (data?.addSubCategory?.status === 200) {
        showToaster({ messageId: id ? 'statusSubCatSuccess' : 'addSubCatSuccess', requestContent: name, toasterType: 'success' });
        return { status: 200 };
      }
      showToaster({ messageId: 'errorMessage', requestContent: data?.addSubCategory?.errorMessage, toasterType: 'error' });
      return { status: 400 };
    } catch (err) {
      showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
      return { status: 400 };
    }
  };
};

export const setSubCategoryStatusInline = (id, fieldValue) => {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation: updateSubCategoryStatusMutation,
        variables: { id, fieldName: 'status', fieldValue },
      });
      if (data?.updateSubCategoryStatus?.status === 200) return { status: 200 };
      showToaster({ messageId: 'errorMessage', requestContent: data?.updateSubCategoryStatus?.errorMessage, toasterType: 'error' });
      return { status: 400 };
    } catch (err) {
      showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
      return { status: 400 };
    }
  };
};

export const deleteSubCategoryInline = (id) => {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation: deleteSubCategoryMutation,
        variables: { id },
      });
      if (data?.deleteSubCategory?.status === 200) {
        showToaster({ messageId: 'removeCatSuccess', toasterType: 'success' });
        return { status: 200 };
      }
      showToaster({ messageId: 'errorMessage', requestContent: data?.deleteSubCategory?.errorMessage, toasterType: 'error' });
      return { status: 400 };
    } catch (err) {
      showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
      return { status: 400 };
    }
  };
};
